(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.ZonesService = (function(superClass) {
    extend(ZonesService, superClass);

    function ZonesService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.getNextColor = bind(this.getNextColor, this);
      this.defaultZoneStyle = bind(this.defaultZoneStyle, this);
      void 0;
    }

    ZonesService.prototype.save = function(data) {
      return this.http.post('backend/grower/layers/management-zones/add-new', {
        'data': data
      });
    };

    ZonesService.prototype.load = function(id, cb) {
      return this.http.post('backend/grower/layers/management-zones/get-object', {
        'id': id
      }).then((function(_this) {
        return function(response) {
          return cb(response);
        };
      })(this));
    };

    ZonesService.prototype.getIrrigationZoneByFieldYear = function(field_id, year) {
      return this.http.post('backend/grower/layers/management-zones/get-existing-irrigation', {
        field_id: field_id,
        year: year
      });
    };

    ZonesService.prototype.hasExistingPreviousCropZone = function(field_id, year) {
      return this.http.post('backend/grower/layers/management-zones/has-existing-previous-crop', {
        field_id: field_id,
        year: year
      });
    };

    ZonesService.prototype.exists = function(id, cb) {
      return this.http.post('backend/grower/layers/management-zones/zone-exists', {
        'id': id
      }).then((function(_this) {
        return function(response) {
          return cb(response);
        };
      })(this));
    };

    ZonesService.prototype.crops = function() {
      return this.http.post('backend/grower/layers/management-zones/get-crops-list').then((function(_this) {
        return function(response) {
          return response.data.data;
        };
      })(this));
    };

    ZonesService.prototype.defaultZoneStyle = function(use_default, fill, weight, use_dash) {
      var color;
      if (use_default == null) {
        use_default = true;
      }
      if (fill == null) {
        fill = false;
      }
      if (weight == null) {
        weight = 2;
      }
      if (use_dash == null) {
        use_dash = false;
      }
      color = use_default === true ? '#FFFFFF' : use_default;
      if (!fill) {
        fill = color;
      }
      return {
        weight: weight,
        fillColor: fill,
        fillOpacity: 0.6,
        color: color,
        dashArray: use_dash ? [10, 8] : void 0
      };
    };

    ZonesService.prototype.setZoneArea = function(zone) {
      zone.area = (function(_this) {
        return function() {
          var geojson;
          geojson = zone.visible.toGeoJSON();
          if (App.is_metric) {
            return turf.area(geojson) * 0.0001;
          } else {
            return turf.area(geojson) * 0.000247105;
          }
        };
      })(this);
      return zone;
    };

    ZonesService.prototype.getNextColor = function(color, by_index) {
      var colors, curr, nextColorIndex;
      if (by_index == null) {
        by_index = null;
      }
      colors = ['#303F99', '#F2DC10', '#F08A2E', '#D51F26', '#00ACE1', '#A65392', '#EB468C', '#008161', '#974B19', '#36415A', '#231F20'];
      if (by_index) {
        return colors[by_index];
      } else {
        curr = colors.indexOf(color);
        nextColorIndex = (curr + 1) % colors.length;
        return colors[nextColorIndex];
      }
    };

    return ZonesService;

  })(Service);

}).call(this);
